"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var cursor = function cursor(_ref) {
  var disabled = _ref.disabled;
  return disabled ? "cursor: default;" : "cursor: pointer;";
};

var TabLabel = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "tab__TabLabel",
  componentId: "sc-17migwt-0"
})(["", ";position:relative;", ";", ";"], cursor, (0, _styles.transitionEase)("0.25s", ["background-color"]), (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.typography));
var RadioInput = (0, _styledComponents["default"])(_primitives["default"].Input).withConfig({
  displayName: "tab__RadioInput",
  componentId: "sc-17migwt-1"
})(["", ";opacity:0;position:absolute;"], cursor);
var Label = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "tab__Label",
  componentId: "sc-17migwt-2"
})(["", ";display:inline-block;"], cursor);
var propTypes = {
  /** Boolean for if tab bar is disabled */
  disabled: _propTypes.bool,

  /** Font styles for label */
  fontObject: _utils.fontPropType,

  /** Id for tab */
  id: _propTypes.string,

  /** Boolean for if tab is selected */
  isChecked: _propTypes.bool,

  /** node or string for label */
  label: _propTypes.node,

  /** Boolean if tab is last in bar */
  last: _propTypes.bool,

  /** Name for group of tabs */
  name: _propTypes.string,

  /** Change handler for the input field */
  onChange: _propTypes.func,

  /** List of options, either array or object  */
  options: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),

  /** Value for tab */
  value: _propTypes.string
};

var TabButton = function TabButton(_ref2) {
  var disabled = _ref2.disabled,
      _ref2$fontObject = _ref2.fontObject,
      fontObject = _ref2$fontObject === void 0 ? _utils.defaultFontSize : _ref2$fontObject,
      id = _ref2.id,
      isChecked = _ref2.isChecked,
      label = _ref2.label,
      last = _ref2.last,
      name = _ref2.name,
      onChange = _ref2.onChange,
      value = _ref2.value;
  return /*#__PURE__*/_react["default"].createElement(TabLabel, {
    alignItems: "center",
    backgroundColor: isChecked ? "background-button" : "background",
    borderRight: last ? "none" : "solid 1px",
    borderRightColor: "blue",
    color: isChecked ? "text-light" : "blue",
    disabled: disabled,
    flex: "1 1 auto",
    htmlFor: id,
    justifyContent: "center",
    px: 1,
    py: 13,
    tag: "label",
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(RadioInput, {
    checked: isChecked,
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    type: "radio",
    value: value
  }), label && /*#__PURE__*/_react["default"].createElement(Label, _extends({
    tag: "span"
  }, fontObject, {
    disabled: disabled
  }), label));
};

TabButton.propTypes = propTypes;
var _default = TabButton;
exports["default"] = _default;